import circular from "./Circular/Circular"
import dots from "./Dots/Dots"
export default {
    circular,
    dots
}